import { render, staticRenderFns } from "./detail-navbar.vue?vue&type=template&id=faa8fb10&scoped=true&"
import script from "./detail-navbar.vue?vue&type=script&lang=js&"
export * from "./detail-navbar.vue?vue&type=script&lang=js&"
import style0 from "./detail-navbar.vue?vue&type=style&index=0&id=faa8fb10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa8fb10",
  null
  
)

export default component.exports